import React from 'react';
import './services.css';
import { Helmet } from "react-helmet";

import whatsapp from '../../Assets/whatsapp.png';
import call from '../../Assets/call.png';
import SnakeBiteMidiPiercingImage from '../../Assets/Piercing Services/snake bite midi piercing (2).png';
import Footer from '../contactus/contactus';

const handleWhatsAppClick = (message) => {
  const url = `https://wa.me/971567257579?text=${encodeURIComponent(message)}`;
  window.open(url, "_blank");
};

function SnakeBiteMidiPiercing() {
  return (
    <div>
      <div className="earlobe-container">
        <Helmet>
          <title>Snake Bite Midi Piercing UAE | 200 AED</title>
        </Helmet>

        <div className="floating-buttons">
          <div
            className='whatsapp-button'
            onClick={() => handleWhatsAppClick("I am interested in Snake Bite Midi Piercing")}
          >
            <img src={whatsapp} alt="WhatsApp" />
          </div>

          <a href="tel:+971567257579" className="call-button">
            <img src={call} alt="Call" />
          </a>
        </div>

        <h1 className="earlobe-title">
          Snake Bite Midi Piercing 200 AED
        </h1>

        <div className="earlobe-image-wrapper">
          <img src={SnakeBiteMidiPiercingImage} alt="Snake Bite Midi Piercing" />
        </div>

        <div className="earlobe-content">
          <h3>Snake Bite Midi Piercing</h3>

          <p>
            Make a bold and edgy statement with our professional Snake Bite Midi piercing services in the UAE, available at an affordable price of 200 AED. Snake Bite Midi piercing is a trendy lip piercing style that creates a striking “snake bite” look, typically featuring symmetrical piercings on the lower lip area. This unique and fashion-forward piercing is perfect for individuals who want to express their individuality and stand out with a confident, modern appearance. Whether you prefer sleek studs or stylish rings, our expert specialists ensure precise placement to achieve a balanced and visually appealing result that enhances your facial features.
          </p>

          <p>
            At our piercing studio, safety, hygiene, and comfort are our top priorities. Our certified professionals use sterile, single-use, high-quality equipment to perform each Snake Bite Midi piercing with accuracy and care. We strictly follow professional hygiene protocols to maintain a clean and sanitized environment, minimizing the risk of infection and ensuring a safe and smooth experience. Lip piercings require expert handling due to their sensitivity, and our skilled specialists use advanced techniques to reduce discomfort and make the procedure as quick and efficient as possible.
          </p>

          <p>
            Snake Bite Midi piercing is ideal for individuals who want a bold and expressive style that reflects their personality. This piercing offers a strong visual impact and pairs well with other facial piercings, allowing you to create a customized and edgy look. Our specialists take the time to understand your preferences and guide you in choosing the best placement and jewelry options to suit your style and comfort. Whether you want a subtle edgy touch or a more dramatic appearance, we tailor the experience to meet your expectations.
          </p>

          <p>
            The procedure is typically completed within minutes, making it convenient even for clients with busy schedules. We also provide high-quality, hypoallergenic starter jewelry that is safe for sensitive skin, helping to prevent irritation and ensure a comfortable healing process. Our goal is to deliver a stylish result while maintaining the highest standards of safety and care.
          </p>

          <p>
            Our clean, welcoming, and professional environment ensures that every client feels relaxed and confident throughout their visit. We understand that lip piercings can feel intimidating, especially for first-time clients, and our friendly staff is always available to answer your questions and provide reassurance. From consultation to completion, we focus on delivering a positive and stress-free experience.
          </p>

          <p>
            Aftercare is an essential part of maintaining your Snake Bite Midi piercing, and we provide detailed instructions to help you care for it properly. Our specialists will guide you on cleaning routines, oral hygiene practices, and precautions to avoid infection or irritation. Following proper aftercare ensures faster healing and helps maintain the appearance and health of your piercing.
          </p>

          <p>
            Our Snake Bite Midi piercing services in the UAE combine affordability with premium quality, offering transparent pricing with no hidden costs. Booking your appointment is quick and convenient, allowing you to choose a time that fits your schedule. We aim to provide minimal waiting time and a seamless experience from start to finish.
          </p>

          <p>
            Choose our trusted Snake Bite Midi piercing services in the UAE for a safe, hygienic, and professional experience. With experienced specialists, precise techniques, and a strong focus on customer satisfaction, we help you achieve a bold and edgy look effortlessly. Book your Snake Bite Midi piercing appointment today and express your individuality with confidence and expert care.
          </p>

          <button
            className="book-btn"
            onClick={() => handleWhatsAppClick("I want to book Snake Bite Midi Piercing")}
          >
            Book Now
          </button>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default SnakeBiteMidiPiercing;